






























































































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { MswApiService } from '@/shared/msw-api-service';
import { InfoState } from '@/core';
import uuifComponent from '@/shared/uuifComponent';

const cssPrefix = 'order-reciept';

@Component({
  components: {
    ...uuifComponent,
  },
})
export default class OrderReciept extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  orderNo: string;
  orderDetailsActKey: any[] = [];
  orderDetailsSno: any[] = [];
  spinner: boolean = false;
  isFormValid = true;
  errorMsg: string = '';
  removeSpinnerStyle: boolean = false;
  orderDetails: any;
  tPrice: number = 0;
  tTax: number = 0;
  isVisible: boolean = true;
  isActiveKeyHeader: boolean = true;
  showData : boolean = false;
  hidePrintButton : boolean = true;
  created() {
    if (this.$router.currentRoute.query.orderId) {
      this.orderNo = this.$router.currentRoute.query.orderId as string;
    }
    this.$store.commit('startLoading');
    MswApiService.orders.getOrderDetails(this.orderNo)
    .then((resp: any) => {
      if (resp.msgCode === 'MSWAPP:SUCCESS') {
        this.orderDetails = resp.content;
        this.createOrderListStructure(resp.content);
      } else if (resp.operationStatus === 'NOK') {
        const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc  };
        this.$store.commit('displayMessage', message);
      }
      this.showData = true;
      this.$store.commit('stopLoading');

    });
  }
  createOrderListStructure(ordrData : any) {
    ordrData.orderDetails.forEach((item : any, index : any) => {
      const desc = item.ssipnDesc;
      const pin = item.ssipn;
      const quant = item.quantity;
      const price = item.price;
      const i = index;
      const l = item?.actKeys?.length;
      let isfirstrow = true;
      this.tPrice = this.tPrice + (price * quant);
      if (item.actKeys) {
        item.actKeys.forEach((val : any) => {
          const temp: any = {};
          temp.ssipnDesc = desc;
          temp.ssipn = pin;
          temp.quantity = quant;
          temp.price = price;
          temp.srNo = i + 1;
          temp.relatedRows = l;
          temp.isfirstrow = isfirstrow;
          isfirstrow = false;
          if (val.actKey === 'N/A') {
            temp.actKey = val.serialNumber;
            temp.isActKey = true;
            temp.serviceStatus = val.serviceStatus;
            this.orderDetailsSno.push(temp);
          } else {
            temp.actKey = val.actKey;
            temp.isActKey = true;
            temp.serviceStatus = val.serviceStatus;
            this.orderDetailsActKey.push(temp);
          }
        });
      }
    });
    if (this.orderDetailsSno.length > 0) {
      if (this.orderDetailsActKey.length > 0) {
        // tslint:disable-next-line:max-line-length
        this.orderDetailsActKey.push({ isActKey: false, actKey: '', isfirstrow: false, price: '', quantity: '', relatedRows: 0, serviceStatus: '', ssipn: '', ssipnDesc: '' });
      } else {
        this.isActiveKeyHeader = false;
      }
      this.orderDetailsSno.forEach((item) => {
        this.orderDetailsActKey.push(item);
      });
    }
  }
  printOrderDetails(event : any) {
    (document.querySelector('#buttonId') as HTMLElement).style.display = 'none';
    window.print();
    (document.querySelector('#buttonId') as HTMLElement).style.display = '';
    console.warn(event);
  }
}
